import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

export const StyledField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s}px;
  margin-bottom: ${({ theme }) => theme.spacing.m}px;
`;

export const StyledFieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing.m}px;
`;

export const StyledLabel = styled.span`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const StyledNote = styled.p.withConfig({ shouldForwardProp })<{
  $tone?: 'info' | 'warning';
}>`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  line-height: 1.4;
  color: ${({ theme, $tone }) =>
    $tone === 'warning' ? theme.colors.warning : theme.colors.textMuted};
`;
